import { Vector3 } from '@babylonjs/core';
export class BoundingBox {
    minimumWorld;
    maximumWorld;
    constructor(minimumWorld, maximumWorld) {
        this.minimumWorld = minimumWorld;
        this.maximumWorld = maximumWorld;
    }
    clone() {
        return new BoundingBox(this.minimumWorld.clone(), this.maximumWorld.clone());
    }
    get min() {
        return this.minimumWorld;
    }
    get max() {
        return this.maximumWorld;
    }
    get centerWorld() {
        return new Vector3((this.minimumWorld.x + this.maximumWorld.x) / 2, (this.minimumWorld.y + this.maximumWorld.y) / 2, (this.minimumWorld.z + this.maximumWorld.z) / 2);
    }
    get extendSizeWorld() {
        return this.maximumWorld.subtract(this.minimumWorld);
    }
    getBoundingSphere(sphere) {
        const center = this.centerWorld;
        const extent = this.extendSizeWorld;
        const radius = extent.length() / 2;
        sphere.center = center;
        sphere.radius = radius;
        return sphere;
    }
}
export class Sphere {
    center;
    radius;
    constructor(center = new Vector3(), radius = 0) {
        this.center = center;
        this.radius = radius;
    }
    clone() {
        return new Sphere(this.center.clone(), this.radius);
    }
}
export class OctreeGeometry {
    loader;
    boundingBox;
    root;
    url = null;
    pointAttributes = null;
    spacing = 0;
    tightBoundingBox;
    numNodesLoading = 0;
    maxNumNodesLoading = 3; // I don't understand why this is also a property of IPotree then. Duplicate functionality?
    boundingSphere;
    tightBoundingSphere;
    offset;
    scale;
    disposed = false;
    projection;
    constructor(loader, boundingBox) {
        this.loader = loader;
        this.boundingBox = boundingBox;
        this.tightBoundingBox = boundingBox.clone();
        // バウンディングボックスからバウンディングスフィアを計算
        const center = boundingBox.centerWorld;
        const extent = boundingBox.extendSizeWorld;
        const radius = extent.length() / 2;
        this.boundingSphere = new Sphere(center, radius);
        this.tightBoundingSphere = new Sphere(center, radius);
    }
    dispose() {
        // this.loader.dispose();
        this.root.traverse((node) => {
            return node.dispose();
        });
        this.disposed = true;
    }
}
